var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"_carousel",staticClass:"carousel"},[_c('div',{staticClass:"carousel-wrapper"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"carousel-slide"},[_c('img',{attrs:{"src":item}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }